export class AuthInteractionInProgressError extends Error {
  constructor() {
    super('AUTH_INTERACTION_IN_PROGRESS');
    this.name = 'AuthInteractionInProgressError';
  }
}

export abstract class AuthProviderPort {
  abstract isConfigured(): boolean;
  abstract initialize(): Promise<boolean>;
  abstract login(): Promise<void>;
  abstract logout(): Promise<boolean>;
}
